/** Central React Query key registry so invalidation stays consistent. */
export const qk = {
  floor: (clubId: string) => ['floor', clubId] as const,
  sessions: (clubId: string) => ['sessions', clubId] as const,
  session: (id: string) => ['session', id] as const,
  bill: (sessionId: string) => ['bill', sessionId] as const,
  overview: (clubId: string) => ['overview', clubId] as const,
  stations: (clubId: string) => ['stations', clubId] as const,
  rateWindows: (clubId: string) => ['rateWindows', clubId] as const,
  menu: (clubId: string) => ['menu', clubId] as const,
  foodOrders: (clubId: string, sessionId?: string | null) =>
    ['foodOrders', clubId, sessionId ?? 'all'] as const,
  bookings: (clubId: string) => ['bookings', clubId] as const,
  customers: (clubId: string) => ['customers', clubId] as const,
  users: (clubId: string) => ['users', clubId] as const,
  clubs: () => ['clubs'] as const,
  payments: (clubId: string) => ['payments', clubId] as const,
  sessionHistory: (clubId: string) => ['sessionHistory', clubId] as const,
  expenses: (clubId: string) => ['expenses', clubId] as const,
  piStatus: () => ['piStatus'] as const,
  activity: (clubId: string) => ['activity', clubId] as const,
  members: (clubId: string) => ['members', clubId] as const,
  member: (id: string) => ['member', id] as const,
  walletTxns: (clubId: string, memberId?: string) =>
    ['walletTxns', clubId, memberId ?? 'all'] as const,
  membershipPlans: (clubId: string) => ['membershipPlans', clubId] as const,
  readerStatus: () => ['readerStatus'] as const,
  receptionists: (clubId: string) => ['receptionists', clubId] as const,
  attendance: (clubId: string) => ['attendance', clubId] as const,
};
